import React, { useState } from "react";
import Header from "./header";
import Footer from "./footer";
import { PopupWidget } from "react-calendly";
import { AiFillSchedule } from "react-icons/ai";
import { IoCloseOutline } from "react-icons/io5";
import CalendlyWidget from "./calendly-widget";

import moment from "moment-business-days";

moment.updateLocale("us", {
  workingWeekdays: [1, 2, 3, 4, 5],
});

const Layout = ({ children }) => {
  const [isCalendlyModalOpen, setIsCalendlyModalOpen] = useState(false);
  const showCalendlyModal = (e) => {
    if (e) e.preventDefault();
    setIsCalendlyModalOpen(true);
  };
  return (
    <div className="container-main">
      <Header showCalendlyModal={showCalendlyModal} />
      {children}
      <Footer />
      {/* <PopupWidget
      url=""https://calendly.com/cloudalgo-sales/30min"
      rootElement={document.getElementById("___gatsby")}
      text="Schedule time with us"
      textColor="#ffffff"
      color="#f75a41"
      pageSettings={{
        backgroundColor: "f8f8f8",
        hideEventTypeDetails: true,
        hideLandingPageDetails: true,
        primaryColor: "f75a41",
        textColor: "4d4d4d",
      }}
      prefill={{
        date: moment().businessAdd(2)._d,
      }}
    /> */}
      {typeof document !== "undefined" && (
        <CalendlyWidget
          isCalendlyModalOpen={isCalendlyModalOpen}
          setIsCalendlyModalOpen={setIsCalendlyModalOpen}
        />
      )}
    </div>
  );
};

export default Layout;
